import { createMediaMathClient } from "@/apis/clients/mediamathClient";
import {
  chunkArray,
  fetchAllPages,
  MAX_IDS_PER_QUERY,
  MAX_PAGE_LIMIT,
} from "@/apis/clients/pagination";
import type { Advertiser, AdvertiserListResponse } from "@/types/advertiser";

const listAdvertisersPage = (q: string, pageOffset: number) =>
  createMediaMathClient()
    .get("advertisers", {
      searchParams: {
        q,
        page_limit: MAX_PAGE_LIMIT,
        page_offset: pageOffset,
        full: true,
      },
    })
    .json<AdvertiserListResponse>();

export const listAdvertisersByOrganization = (organizationId: number) =>
  fetchAllPages((pageOffset) =>
    listAdvertisersPage(`organization_id==${organizationId}`, pageOffset)
  );

export const listAdvertisersByAgencies = async (
  agencyIds: number[]
): Promise<Advertiser[]> => {
  const results = await Promise.all(
    chunkArray(agencyIds, MAX_IDS_PER_QUERY).map((chunk) =>
      fetchAllPages((pageOffset) =>
        listAdvertisersPage(`agency_id==(${chunk.join(",")})`, pageOffset)
      )
    )
  );
  return results.flat();
};
